export const environment = {
    production: true,
    API_BASE_URL: 'https://wasessenwir.jetzt/directus',
    GA4_PROPERTY: 'G-D8K6SVFH0T',
};
